<div class="cart-view" *ngIf="(isVisible$ | async)">
    <div class="cart-view__inner">
        <shared-btn (onClick)="handleClick($event)" class="cart-view__btn" [size]="size" [badgeSize]="badgeSize"
            [badgeLeft]="quantity$ | async">view
            order &nbsp;
            {{value$ | async | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}
        </shared-btn>
    </div>
</div>
